<template>
  <div>
    <div class="tab-title">我的音频</div>
    <div class="edit-video-container">
      <EditAudio />
    </div>
    <div class="feed-list-container" v-loading="feedShade">
      <AudioItem
        v-for="feed in feedList"
        :key="feed.id"
        :feed="feed"
        :page="feedPage"
      />
      <p class="no-feed" v-if="feedList.length == 0">{{ noFeedText }}</p>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        layout="prev, pager, next"
        :total="totalPage"
        prev-text="上一页"
        next-text="下一页"
        hide-on-single-page
        ref="pagination"
        @current-change="curtListPageClick"
      >
      </el-pagination>
      <!-- @prev-click="prevtListPageClick" @next-click="nextListPageClick" -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../utils/apiMap";
import EditAudio from "../../components/user/edit-audio";
import AudioItem from "../../components/user/storeroom/audio-item";
export default {
  name: "user-audio",
  data() {
    return {
      feedShade: true,
      feedPage: 1,
      feedList: [],
      feedTotal: 0,
      noFeedText: "",
      AlbumID: 0,
    };
  },
  components: {
    EditAudio,
    AudioItem,
  },
  computed: {
    ...mapGetters(["userCenterSign"]),
    totalPage() {
      return this.feedTotal;
    },
  },
  mounted() {
    this.feedPage = this.userCenterSign.aduioPage || 1;
    this.getAudioList(this.feedPage);
    this.$bus.$on("reload-audio-list", this.reloadAudioList);
  },
  methods: {
    getAudioList(page) {
      let _this = this;
      _this.getListBtn = false;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["audioList"]["method"],
          url: apiMap["audioList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            type: 1,
          },
        })
        .then(function (response) {
          _this.feedShade = false;
          if (response.data.result.statusCode == 1) {
            _this.feedList = response.data.result.data;
            _this.feedTotal = response.data.result.count;
            _this.$refs.pagination.internalCurrentPage = page;
          } else {
            _this.noFeedText = "暂无音频";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    prevtListPageClick(newPage) {
      //即将加载的起始页
      this.feedPage = newPage;
      this.getAudioList(newPage);
    },
    curtListPageClick(newPage) {
      //即将加载的起始页
      this.feedPage = newPage;
      this.getAudioList(newPage);
    },
    nextListPageClick(newPage) {
      this.feedPage = newPage;
      this.getAudioList(newPage);
    },
    reloadAudioList() {
      this.feedShade = true;
      this.feedTotal = 0;
      this.feedList = [];
      this.getAudioList(this.feedPage);
    },
  },
};
</script>
<style scoped>
.tab-title {
  height: 40px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #1a70db;
}

.edit-video-container {
  width: 840px;
  padding: 10px 15px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #fff;
}

.feed-list-container {
  min-height: 120px;
}

.no-feed {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #fff;
}

.pagination-wrapper {
  margin-bottom: 15px;
  padding: 5px 0;
  text-align: center;
  background-color: #fff;
}

.pagination-wrapper:empty {
  padding: 0;
}
</style>